import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Fetch delivery zone areas by ID
 * @returns {Promise<Object>} - Response data from the API
 */
export const getAreasApi = async () => {
  try {
    const response = await apiClient.get(
      `${API_ENDPOINTS.ALL_AREAS}?country_id=3`
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
